import { X } from '@hungryroot/icons';
import {
  IconButton,
  type IconButtonProminenceVariant,
  type IconButtonSizeVariant,
  type IconButtonStyleVariant,
} from '@hungryroot/ramen';
import styles from './XButton.module.css';

interface XButtonProps {
  onClick: () => void;
  className?: string;
  size?: IconButtonSizeVariant;
  style?: IconButtonStyleVariant;
  prominence?: IconButtonProminenceVariant;
  testid?: string;
}

export function XButton(props: XButtonProps) {
  const {
    onClick,
    className,
    size = 'small',
    style = 'inverted',
    prominence = 'primary',
    testid,
  } = props;
  return (
    <IconButton
      ariaLabel="X"
      testid={testid}
      className={className}
      size={size}
      style={style}
      prominence={prominence}
      onClick={onClick}
      icon={
        <div className={styles.x}>
          <X />
        </div>
      }
    ></IconButton>
  );
}
